export const vi = {
    translation: {
        b: {
            cancel: 'Hủy',
            confirm: 'Xác nhận',
            send: 'Gửi',
            done: 'Hoàn tất',
            close: 'Đóng',
            clear: 'Xóa',
            copy_link: 'Sao chép liên kết',
            export: 'Xuất',
            delete: 'Xóa',
            delete_confirm: 'Xác nhận xóa',
            duplicate: 'Nhân bản',
            share: 'Chia sẻ',
            sign_in: 'Đăng nhập',
            sign_up: 'Đăng ký',
            email_address: 'Địa chỉ email',
            yes: 'Có',
            no: 'Không',
            back: 'Quay lại',
            upgrade: 'Nâng cấp',
            remove: 'Xóa bỏ',
            restore: 'Khôi phục',
            archive: 'Lưu trữ',
            rename: 'Đổi tên',
            leave: 'Rời khỏi',
            import: 'Nhập',
            continue: 'Tiếp tục',
            settings: 'Cài đặt',
            log_out: 'Đăng xuất',
            invite: 'Mời',
            invited: 'Đã mời',
        },
        roles: {
            view: 'Người xem',
            comment: 'Người bình luận',
            edit: 'Người chỉnh sửa',
            admin: 'Quản trị viên',
            owner: 'Chủ sở hữu',
            member: 'Thành viên',
            remove: 'Xóa bỏ',
            more_roles: 'Thêm vai trò...',
            change_role: 'Thay đổi vai trò...',
            remove_access: 'Xóa quyền truy cập...',
            remove_invite: 'Xóa lời mời...',
        },
        db_engine: {
            basic: 'SQL cơ bản',
            general: 'SQL tổng quát',
        },
        socket_status: {
            reconnecting: 'Đang kết nối lại...',
            offline: 'Bạn đang ngoại tuyến. Đang kết nối lại...',
        },
        loader: {
            diagram: 'Đang tải sơ đồ...',
        },
        m_languages: {
            title: 'Ngôn ngữ',
            subtitle: 'Chọn ngôn ngữ'
        },
        m_feedback: {
            feature: {
                name: 'Yêu cầu tính năng',
                desc: 'Thiếu tính năng bạn cần? Hãy cho chúng tôi biết — ý tưởng của bạn rất quan trọng'
            },
            feedback: {
                name: 'Chia sẻ phản hồi của bạn',
                desc: 'Chúng tôi rất muốn biết bạn nghĩ gì'
            },
            support: {
                name: 'Hỗ trợ',
                desc: 'Có điều gì đó không hoạt động? Hãy cho chúng tôi biết — chúng tôi sẽ khắc phục nhanh chóng',
            },
            bug: {
                name: 'Báo cáo sự cố',
                desc: 'Có điều gì đó chưa ổn? Hãy báo cáo cho chúng tôi — chúng tôi sẽ xử lý nhanh chóng',
            },
            integration: {
                name: 'Yêu cầu tích hợp',
                desc: 'Phản hồi của bạn rất quan trọng đối với chúng tôi — hãy để lại một ghi chú ngắn',
            },
        },
        m_feedback_t: {
            feature: {
                name: 'Cảm ơn bạn về đề xuất!',
                desc: 'Chúng tôi rất trân trọng thời gian bạn chia sẻ ý kiến — điều đó giúp chúng tôi cải thiện.'
            },
            feedback: {
                name: 'Cảm ơn bạn về phản hồi!',
                desc: 'Chúng tôi rất trân trọng thời gian bạn chia sẻ ý kiến — điều đó giúp chúng tôi cải thiện.'
            },
            support: {
                name: 'Cảm ơn bạn đã liên hệ!',
                desc: 'Cảm ơn bạn đã liên hệ với bộ phận hỗ trợ — chúng tôi sẽ xem xét yêu cầu và phản hồi sớm nhất có thể.',
            },
            bug: {
                name: 'Cảm ơn bạn đã báo cáo!',
                desc: 'Cảm ơn bạn đã báo cáo điều này — điều đó giúp chúng tôi khắc phục sự cố nhanh hơn và liên tục cải thiện trải nghiệm.',
            },
            contact: {
                name: 'Cảm ơn bạn đã liên hệ!',
                desc: 'Chúng tôi đã nhận được tin nhắn của bạn và sẽ phản hồi sớm nhất có thể.',
            },
            invite_people: {
                name: 'Đã gửi lời mời thành công!',
                desc: 'Cảm ơn bạn đã lan tỏa — chúng tôi rất mong được chào đón họ.',
            },
            integration: {
                name: 'Cảm ơn bạn về đề xuất!',
                desc: 'Chúng tôi rất trân trọng thời gian bạn chia sẻ ý kiến — điều đó giúp chúng tôi cải thiện.',
            },
        },
        m_diagram_details: {
            name_place: 'Nhập tên dự án',
            desc_place: 'Nhập mô tả dự án'
        },
        m_quick_share: {
            title: 'Chia sẻ nhanh',
            subtitle: '(Qua liên kết)'
        },
        m_export_img: {
            title: 'Xuất hình ảnh'
        },
        search_menu: {
            placeholder: 'Tìm kiếm bảng, cột, kiểu dữ liệu...',
            hint: '',
            no_results: 'Không có kết quả',
            quick_results: 'Kết quả nhanh cho',
            untitled: 'chưa đặt tên',
            command_tag: 'lệnh',
            section_tables: 'Bảng',
            section_columns: 'Cột',
            section_canvas: 'Khung vẽ',
            section_export: 'Xuất',
            section_preferences: 'Tùy chọn',
            section_settings: 'Cài đặt',
            type_table: 'bảng',
            type_note: 'ghi chú',
            cmd_new_table: 'Tạo bảng mới...',
            cmd_new_note: 'Tạo ghi chú mới...',
            cmd_new_line: 'Tạo đường mới...',
            cmd_new_area: 'Tạo khu vực mới...',
            cmd_export_image: 'Xuất hình ảnh...',
            cmd_export_sql: 'Xuất mã SQL...',
            cmd_grid_style: 'Thay đổi bố cục lưới...',
        },
        canvas_table: {
            more_column: 'cột khác',
            more_columns: 'cột khác',
            tooltip_table: 'Bảng',
            tooltip_indexes: 'Chỉ mục',
            tooltip_enum: 'Enum',
            tooltip_default: 'Mặc định',
            tooltip_generated: 'Được tạo tự động',
            tooltip_check: 'Kiểm tra',
        },
        m_export_code: {
            title: 'Xuất mã {{db_engine}}',
            download_file: 'Tải xuống tệp',
            copy_code: 'Sao chép mã'
        },
        m_sign_in_remind: {
            title: 'Cảm ơn bạn đã dùng thử DB Design',
            subtitle: 'Đăng nhập hoặc đăng ký để tăng số lượng bảng tối đa, lưu sơ đồ và mở khóa thêm tính năng.'
        },
        m_sign_in_restrict: {
            title: 'Đăng nhập để làm được nhiều hơn trong ứng dụng',
            subtitle: 'Đăng nhập hoặc đăng ký để tăng giới hạn bảng, lưu sơ đồ và mở khóa thêm tính năng.'
        },
        m_new_diagram: {
            title: 'Sơ đồ mới',
            subtitle: 'Chọn công cụ cơ sở dữ liệu',
            open_diagram: 'Mở sơ đồ',
            create_diagram: 'Tạo sơ đồ',
            no_workspace: 'Hãy tạo một không gian làm việc trước để bắt đầu tạo sơ đồ.',
            build_something_new: 'Hãy cùng xây dựng điều gì đó mới',
            create_diagram_section: 'Tạo sơ đồ',
            clone_template_btn: 'Nhân bản mẫu',
        },
        m_diagram_name: {
            enter_new_name: 'Nhập tên sơ đồ mới',
        },
        m_diagram_clone: {
            header: 'Nhân bản sơ đồ',
            copy_of_title: 'Bản sao của {{title}}',
        },
        m_diagram_rename: {
            header: 'Đổi tên sơ đồ',
        },
        m_template_clone: {
            header: 'Tạo sơ đồ từ mẫu',
        },
        m_diagram_delete: {
            header: 'Xóa sơ đồ',
            desc_prefix: 'Thao tác này sẽ xóa ',
        },
        m_diagram_archive: {
            header: 'Lưu trữ sơ đồ',
            desc_prefix: 'Thao tác này sẽ lưu trữ ',
        },
        m_diagram_restore: {
            header: 'Khôi phục sơ đồ',
            desc_prefix: 'Thao tác này sẽ khôi phục ',
        },
        m_diagram_import: {
            sql_name: 'Nhập mã SQL',
            dbml_name: 'Nhập mã DBML',
            placeholder: 'Chúng tôi rất muốn nghe ý kiến của bạn!',
        },
        m_diagram_not_found: {
            header: 'Không tìm thấy sơ đồ',
            desc: 'Chúng tôi không thể tìm thấy sơ đồ bạn đang tìm kiếm.',
            back_to_app: 'Quay lại ứng dụng',
        },
        m_diagram_share: {
            header: 'Chia sẻ sơ đồ – {{title}}',
            owner_only_invite: 'Chỉ chủ sở hữu mới có thể mời thành viên mới',
            invited_to_workspace: 'Đã mời vào không gian làm việc',
            you: 'bạn',
            email_placeholder: 'Nhập email',
            email_already_in_list: 'email đã có trong danh sách',
            will_be_invited_to_workspace: 'sẽ được mời vào không gian làm việc',
        },
        m_invite_people: {
            header: 'Mời vào không gian làm việc',
        },
        m_invite_revoke: {
            header: 'Gỡ lời mời',
            desc_prefix: 'Gỡ lời mời cho ',
            desc_suffix: 'Lời mời sẽ không còn hiệu lực.',
        },
        m_member_remove: {
            header: 'Xóa thành viên',
            desc_prefix: 'Xóa ',
            desc_suffix: 'khỏi không gian làm việc này? Họ sẽ mất quyền truy cập.',
        },
        m_template_details: {
            preview: 'Xem trước',
            use_template: 'Sử dụng mẫu',
        },
        m_workspace_create: {
            header: 'Tạo không gian làm việc mới',
            name_label: 'Tên',
            setup_config_label: 'Cấu hình thiết lập',
            setup_config_value: 'Không gian làm việc trống',
            template_structure_label: 'Mẫu/Cấu trúc',
            template_structure_value: 'Tải trước cấu trúc',
            placeholder: 'Nhập tên không gian làm việc',
            create_button: 'Tạo không gian làm việc',
            creating: 'Đang tạo không gian làm việc của bạn...',
        },
        m_workspace_delete: {
            header: 'Xóa không gian làm việc',
            desc_prefix: 'Thao tác này sẽ xóa vĩnh viễn ',
            confirm_prefix: 'Nhập ',
            confirm_suffix: ' để xác nhận.',
        },
        m_workspace_leave: {
            header: 'Rời khỏi không gian làm việc',
            desc_prefix: 'Thao tác này sẽ xóa bạn khỏi ',
            desc_suffix: 'Bạn sẽ cần được mời lại để tham gia lại.',
        },
        m_workspace_menu: {
            manage_members: 'Quản lý thành viên',
            switch_workspace: 'Chuyển không gian làm việc',
            workspaces_label: 'Không gian làm việc',
            create_workspace: 'Tạo không gian làm việc...',
            switching: 'Đang chuyển',
        },
        m_profile_menu: {
            profile: 'Hồ sơ',
            onboarding: 'Hướng dẫn bắt đầu',
        },
        m_pricing_limit: {
            admin_roles: { title: 'Nâng tầm hợp tác của bạn', description: 'Nâng cấp để mở khóa thêm vai trò chia sẻ như Quản trị viên, Người chỉnh sửa, Người bình luận, Người xem.' },
            workspaces: { title: 'Bạn đang phát triển nhanh chóng!', description: 'Nâng cấp để tạo và quản lý thêm không gian làm việc cho dự án và nhóm của bạn.' },
            workspaces_canvas: { title: 'Mở rộng không gian làm việc của bạn', description: 'Nâng cấp để tạo và quản lý thêm không gian làm việc cho dự án và nhóm của bạn.' },
            members: { title: 'Hợp tác ở quy mô lớn', description: 'Nâng cấp để mời thêm thành viên vào không gian làm việc và hợp tác hiệu quả hơn.' },
            diagrams: { title: 'Bạn đang phát triển nhanh chóng!', description: 'Nâng cấp để tạo thêm sơ đồ và phát triển dự án của bạn một cách tự tin.' },
            tables: { title: 'Tạo không giới hạn', description: 'Nâng cấp để thêm nhiều bảng hơn và tiếp tục xây dựng những sơ đồ lớn hơn, chi tiết hơn.' },
            columns: { title: 'Tạo không giới hạn', description: 'Nâng cấp để thêm nhiều cột hơn và tiếp tục xây dựng những sơ đồ lớn hơn, chi tiết hơn.' },
            notes: { title: 'Tạo không giới hạn', description: 'Nâng cấp để thêm nhiều ghi chú hơn và tiếp tục xây dựng những sơ đồ lớn hơn, chi tiết hơn.' },
            areas: { title: 'Tạo không giới hạn', description: 'Nâng cấp để thêm nhiều khu vực hơn và tiếp tục xây dựng những sơ đồ lớn hơn, chi tiết hơn.' },
            pens: { title: 'Tạo không giới hạn', description: 'Nâng cấp để thêm nhiều bản vẽ hơn và tiếp tục xây dựng những sơ đồ lớn hơn, chi tiết hơn.' },
            default_title: 'Nâng tầm hợp tác của bạn',
            default_title_canvas: 'Nâng tầm hiệu suất của bạn',
        },
        m_pricing_plans: {
            title: 'Nâng cấp gói của bạn',
            subtitle: 'Bạn luôn có thể nâng cấp hoặc hạ cấp gói của mình sau',
            monthly: 'Hàng tháng',
            annually: 'Hàng năm',
            billed_annually: 'Thanh toán hàng năm',
            billed_monthly: 'Thanh toán hàng tháng',
            free_for_everyone: 'Miễn phí cho tất cả mọi người',
            current_plan: 'Gói hiện tại',
            will_be_available_soon: 'Sẽ sớm ra mắt',
            price_period_user_month: '/người dùng/tháng',
            plan_free: {
                name: 'Miễn phí',
                button: 'Đổi gói',
                feature_realtime: 'Hợp tác theo thời gian thực',
                feature_members: '4 thành viên / không gian làm việc',
                feature_diagrams: '4 sơ đồ / không gian làm việc',
                feature_tables: '40 bảng / sơ đồ',
            },
            plan_pro: {
                name: 'Pro',
                feature_all_free: 'Tất cả tính năng của gói Miễn phí +',
                feature_members: 'Không giới hạn thành viên',
                feature_diagrams: 'Không giới hạn sơ đồ',
                feature_tables: 'Không giới hạn bảng',
                feature_history: 'Lịch sử phiên bản',
                feature_admin_roles: 'Vai trò quản trị viên',
            },
        },
        sidebar: {
            new: 'Mới',
            pinned_diagrams: 'Sơ đồ đã ghim',
            pin_hint: 'Ghim sơ đồ để xem chúng ở đây',
            expand_sidebar: 'Mở rộng thanh bên',
            home_aria: 'Trang chủ DB Design',
            open_menu: 'Mở menu',
            close_menu: 'Đóng menu',
            sidebar_menu_aria: 'Menu thanh bên',
            plan_suffix: 'gói',
            diagram_options: 'Tùy chọn sơ đồ',
            pin: 'Ghim',
            unpin: 'Bỏ ghim',
            edit_details: 'Chỉnh sửa chi tiết',
            see_details: 'Xem chi tiết',
            invite_people: 'Mời',
            collapse_sidebar: 'Thu gọn thanh bên',
            close_sidebar: 'Đóng thanh bên',
            open_sidebar: 'Mở thanh bên',
            open_new_tab: 'Mở trong tab mới',
        },
        focus_controls: {
            show_top: 'Hiện điều khiển trên cùng',
            hide_top: 'Ẩn điều khiển trên cùng',
            show_left: 'Hiện điều khiển bên trái',
            hide_left: 'Ẩn điều khiển bên trái',
        },
        m_keyboard_shortcuts: {
            title: 'Phím tắt',
            general: {
                title1: 'Chung',
                title2: '',
                items: {
                    new_diagram: 'Tạo sơ đồ',
                    new_chat: 'Cuộc trò chuyện mới',
                    search: 'Thao tác nhanh hoặc tìm kiếm',
                    preferences: 'Tùy chọn',
                    settings: 'Cài đặt',
                    keyboard_shortcuts: 'Phím tắt',
                    toggle_sidebar: 'Bật/tắt thanh bên',
                    toggle_theme: 'Bật/tắt giao diện',
                },
            },
            ctrl_left: {
                title1: 'Điều khiển',
                title2: '(Trái)',
                items: {
                    mouse_sel: 'Chọn bằng chuột / Chế độ bàn tay',
                    table: 'Bảng',
                    line: 'Đường',
                    area: 'Khu vực',
                    note: 'Ghi chú',
                    comment: 'Bình luận',
                    pen: 'Bút',
                    undo: 'Hoàn tác',
                    redo: 'Làm lại'
                },
            },
            ctrl_top_left: {
                title1: 'Điều khiển',
                title2: '(Trên trái)',
                items: {
                    export_img: 'Xuất hình ảnh',
                    search: 'Tìm kiếm',
                    editor_panel: 'Bảng trình soạn thảo',
                    zoom_to_fit: 'Vừa màn hình',
                },
            },
            ctrl_bottom_right: {
                title1: 'Điều khiển',
                title2: '(Dưới phải)',
                items: {
                    minimap: 'Bản đồ thu nhỏ',
                    full_screen: 'Toàn màn hình',
                    zoom_in: 'Phóng to',
                    zoom_out: 'Thu nhỏ',
                    zoom_100: 'Zoom 100%'
                },
            },
            ctx_tab: {
                title1: 'Menu ngữ cảnh',
                title2: '(Bảng)',
                items: {
                    dupl_tab: 'Nhân bản bảng',
                    del_tab: 'Xóa bảng'
                },
            },
            ctx_del_tab: {
                title1: 'Menu ngữ cảnh',
                title2: '(Xóa bảng)',
                items: {
                    yes: 'Có',
                    no: 'Không'
                },
            },
            ctx_tab_col: {
                title1: 'Menu ngữ cảnh',
                title2: '(Cột của bảng)',
                items: {
                    add_col_below: 'Thêm cột bên dưới',
                    focus_col_above: 'Di chuyển tiêu điểm đến cột phía trên',
                    focus_col_below: 'Di chuyển tiêu điểm đến cột phía dưới',
                    move_col_up: 'Di chuyển cột lên',
                    move_col_down: 'Di chuyển cột xuống',
                    dupl_col: 'Nhân bản cột',
                    del_col: 'Xóa cột'
                },
            },
            ctx_line: {
                title1: 'Menu ngữ cảnh',
                title2: '(Đường)',
                items: {
                    del_line: 'Xóa đường'
                },
            },
            ctx_area: {
                title1: 'Menu ngữ cảnh',
                title2: '(Khu vực)',
                items: {
                    dupl_area: 'Nhân bản khu vực',
                    del_area: 'Xóa khu vực'
                },
            },
            ctx_multi: {
                title1: 'Menu ngữ cảnh',
                title2: '(Chọn nhiều)',
                items: {
                    select_all: 'Chọn tất cả phần tử',
                    create_area_for_select_els: 'Tạo khu vực cho các phần tử đã chọn',
                    dupl_select_els: 'Nhân bản các phần tử đã chọn',
                    del_select_els: 'Xóa các phần tử đã chọn'
                },
            },
        },
        t: {
            ctrl_left: {
                mouse_select: 'Chọn bằng chuột',
                table: 'Bảng',
                line: 'Đường',
                area: 'Khu vực',
                note: 'Ghi chú',
                comment: 'Bình luận',
                pen: 'Bút',
                undo: 'Hoàn tác',
                redo: 'Làm lại'
            },
            ctrl_top_left: {
                home: 'Trang chủ',
                name: 'Thông tin sơ đồ',
                editor: 'Trình soạn thảo',
                search: 'Tìm kiếm',
                export: 'Tùy chọn xuất',
                view_mode: 'Chế độ xem',
                zoom_to_fit: 'Vừa màn hình',
                grid: 'Bố cục lưới',
                history: 'Lịch sử',
                main_menu: 'Menu chính',
                new_diagram: 'Sơ đồ mới',
            },
            ctrl_top_right: {
                feature_req: 'Yêu cầu tính năng',
                feedback: 'Gửi phản hồi',
                sign_in: 'Đăng nhập',
                quick_share: 'Chia sẻ nhanh'
            },
            ctrl_bottom_right: {
                full_screen: 'Toàn màn hình',
                minimap: 'Bản đồ thu nhỏ',
                zoom_out: 'Thu nhỏ',
                zoom_100: 'Zoom 100%',
                zoom_in: 'Phóng to',
                info: 'Thông tin & tài nguyên'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Mặc định',
                        blue: 'Xanh dương',
                        green: 'Xanh lục',
                        red: 'Đỏ',
                        purple: 'Tím',
                        violet: 'Tím violet'
                    },
                    borders: {
                        none: 'Không',
                        solid: 'Liền',
                        dashed: 'Gạch đứt',
                        dotted: 'Chấm'
                    },
                    color: 'Màu',
                    border: 'Viền',
                    description: 'Mô tả',
                    description_table_place: 'Mô tả bảng',
                    description_column_place: 'Mô tả cột',
                    description_line_place: 'Mô tả đường',
                    description_note_place: 'Mô tả ghi chú',
                    description_area_place: 'Mô tả khu vực',
                    description_pen_place: 'Mô tả bút',
                    hide_menu: 'Ẩn menu',
                    show_menu: 'Hiện menu'
                },
                tab_col: {
                    add_col_below: 'Thêm cột bên dưới',
                    add_col_above: 'Thêm cột bên trên',
                    key: 'Key',
                    keys: {
                        none: 'Không',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Không',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Di chuyển cột xuống',
                    move_col_up: 'Di chuyển cột lên',
                    more_functions: 'Thêm chức năng'
                },
                line: {
                    change_connects: 'Thay đổi đầu nối',
                    connects: {
                        empty: 'Trống',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_many_to: 'One or Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update Trigger',
                    on_delete: 'On Delete Trigger'
                },
                area: {
                    filter: 'Lọc phần tử'
                },
                note: {
                    link_placeholder: 'Nhập liên kết',
                    link_apply: 'Thêm',
                    link_remove: 'Xóa bỏ',
                    link_edit: 'Chỉnh sửa',
                    link_needs_selection: 'Chọn văn bản để thêm liên kết',
                    bulleted_list: 'Danh sách',
                    numbered_list: 'Danh sách có số thứ tự',
                    font_style: 'Kiểu chữ',
                    alignment: 'Căn chỉnh',
                    align_left: 'Căn trái',
                    align_center: 'Căn giữa',
                    align_right: 'Căn phải',
                    link: 'Liên kết',
                    monospace: 'Chữ đơn cách',
                    bold: 'In đậm',
                    italic: 'In nghiêng',
                    underline: 'Gạch chân',
                    strikethrough: 'Gạch ngang',
                },
                multi: {
                    filter: 'Lọc lựa chọn',
                    create_area: 'Tạo khu vực'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Đầy đủ',
            keys_only: 'Chỉ khóa',
            names_only: 'Chỉ tên'
        },
        dropdown_ctrl_grid: {
            none: 'Không',
            lines: 'Đường kẻ',
            dots: 'Chấm',
        },
        dropdown_ctrl_export: {
            export_img: 'Xuất hình ảnh',
            export_code: 'Xuất mã SQL'
        },
        dropdown_ctrl_settings: {
            back_home: 'Về trang chủ',
            sign_in: 'Đăng nhập',
            preferences: 'Tùy chọn',
            new_project: 'Dự án mới',
            import_diagram: 'Nhập sơ đồ',
            duplicate_diagram: 'Nhân bản sơ đồ',
            keyboard_shortcuts: 'Phím tắt',
            languages: 'Ngôn ngữ',
            view: 'Xem',
            upgrade_plan: 'Nâng cấp gói',
            language: 'Ngôn ngữ',
            mouse_trackpad: 'Chuột hoặc bàn di chuột',
            background_color: 'Màu nền',
            grid_layout: 'Bố cục lưới',
            view_mode: 'Chế độ xem',
            show_align_lines: 'Hiện đường căn chỉnh',
            show_members_cursors: 'Hiện con trỏ của thành viên',
            show_comments: 'Hiện bình luận',
            undo_redo_controls: 'Điều khiển hoàn tác/làm lại',
            show_scrollbars: 'Hiện thanh cuộn',
            opt_auto: 'Tự động',
            opt_trackpad: 'Bàn di chuột',
            opt_mouse: 'Chuột',
            opt_default: 'Tối (mặc định)',
            opt_gray: 'Xám',
            opt_blue: 'Xanh dương',
            opt_purple: 'Tím',
            opt_violet: 'Tím violet',
            opt_green: 'Xanh lục',
            opt_red: 'Đỏ',
            opt_yellow: 'Vàng',
            opt_dots: 'Chấm',
            opt_lines: 'Đường kẻ',
            opt_none: 'Không',
            opt_full: 'Đầy đủ',
            opt_keys: 'Khóa',
            opt_names: 'Tên',
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Phản hồi',
            keyboard_shortcuts: 'Phím tắt',
            languages: 'Ngôn ngữ',
            homepage: 'Trang chủ'
        },
        n: {
            default: 'Đang tải…',
            file_ready_to_download: 'Tệp đã sẵn sàng để tải xuống',
            code_copied: 'Mã đã được sao chép',
            link_copied: 'Liên kết đã được sao chép',
            username_copied: 'Tên người dùng đã được sao chép',
            email_copied: 'Email đã được sao chép',
            please_enter_message: 'Vui lòng nhập tin nhắn',
            invalid_email: 'Email không hợp lệ',
            note_link_unsupported_protocol: 'Loại liên kết không được hỗ trợ. Hãy dùng https, http, mailto.',
            something_wrong_contact: 'Đã xảy ra lỗi. Vui lòng tải lại trang hoặc liên hệ với chúng tôi.',
            something_wrong: 'Đã xảy ra lỗi. Vui lòng tải lại trang.',
            sending: 'Đang gửi…',
            request_sent: 'Yêu cầu đã được gửi. Cảm ơn bạn!',

            please_enter_email: 'Vui lòng nhập địa chỉ email',
            changing: 'Đang thay đổi...',
            role_changed: 'Đã thay đổi vai trò',
            removing: 'Đang xóa...',
            member_removed: 'Đã xóa thành viên',
            inviting: 'Đang mời...',
            invite_sent: 'Đã gửi lời mời',
            added_to_diagram: 'Đã thêm vào sơ đồ',
            invite_removed: 'Đã gỡ lời mời',
            role_not_allowed_on_plan: 'Vai trò này không khả dụng trong gói của bạn. Nâng cấp để gán vai trò này.',
            already_diagram_member: 'Người này đã có quyền truy cập vào sơ đồ.',
            cannot_invite_to_workspace: 'Hãy nhờ quản trị viên không gian làm việc mời người này vào không gian làm việc.',
            saving: 'Đang lưu...',
            saved: 'Đã lưu',
            diagram_renamed: 'Đã đổi tên sơ đồ',
            diagram_updated: 'Đã cập nhật sơ đồ',
            duplicating: 'Đang nhân bản...',
            diagram_duplicated: 'Đã nhân bản sơ đồ',
            deleting: 'Đang xóa...',
            diagram_archived: 'Đã lưu trữ sơ đồ',
            diagram_deleted: 'Đã xóa sơ đồ',
            restoring: 'Đang khôi phục...',
            diagram_restored: 'Đã khôi phục sơ đồ',
            diagram_pinned: 'Đã ghim sơ đồ',
            diagram_unpinned: 'Đã bỏ ghim sơ đồ',
            creating: 'Đang tạo...',
            diagram_created: 'Đã tạo sơ đồ',
            forbidden: 'Bạn không có quyền truy cập vào nội dung đó.',
            invite_already_pending: 'Người này đã có một lời mời đang chờ xử lý.',
            already_member: 'Đã là thành viên của không gian làm việc',
            cannot_invite_self: 'Bạn không thể mời chính mình',
            workspace_not_found: 'Không tìm thấy không gian làm việc. Hãy làm mới trang và thử lại.',
            diagram_not_found: 'Không tìm thấy sơ đồ.',
            has_diagram_members: 'Sơ đồ có thành viên đang hoạt động',
            seat_limit_reached: 'Bạn đã đạt giới hạn số chỗ trong gói của mình. Nâng cấp để mời thêm người.',
            feature_not_in_plan: 'Tính năng này không có trong gói hiện tại của bạn.',
            subscription_expired: 'Gói đăng ký của bạn đã hết hạn. Hãy gia hạn để tiếp tục sử dụng.',
            subscription_inactive: 'Gói đăng ký của bạn chưa hoạt động. Vui lòng cập nhật thông tin thanh toán.',
            plan_limit_generic: 'Gói của bạn không cho phép thao tác này. Nâng cấp để tiếp tục.',

            // Auth / profile
            session_expired: 'Phiên của bạn đã hết hạn — vui lòng đăng nhập lại.',
            profile_updated: 'Đã cập nhật hồ sơ',
            profile_update_failed: 'Cập nhật hồ sơ thất bại.',
            account_delete_failed: 'Xóa tài khoản thất bại.',

            // Preferences
            couldnt_save: 'Không thể lưu thay đổi',
            try_again: 'Đã xảy ra lỗi. Vui lòng thử lại.',

            // Workspace
            not_workspace_member: 'Bạn không phải là thành viên của không gian làm việc đó.',
            workspace_switch_failed: 'Không thể chuyển không gian làm việc. Vui lòng thử lại.',
            workspace_create_failed: 'Không thể tạo không gian làm việc. Vui lòng thử lại.',
            invalid_workspace_name: 'Tên không gian làm việc không hợp lệ',
            workspace_updated: 'Đã cập nhật không gian làm việc',
            workspace_update_failed: 'Không thể cập nhật không gian làm việc. Vui lòng thử lại.',
            last_owner_cannot_leave: 'Bạn là chủ sở hữu duy nhất. Hãy chỉ định người khác làm chủ sở hữu, hoặc xóa không gian làm việc, trước khi rời đi.',
            workspace_leave_failed: 'Không thể rời khỏi không gian làm việc. Vui lòng thử lại.',
            workspace_delete_forbidden: 'Chỉ chủ sở hữu không gian làm việc mới có thể xóa không gian làm việc này.',
            workspace_has_active_billing: 'Hãy hủy gói đăng ký của không gian làm việc này trước khi xóa.',
            workspace_deleted: 'Đã xóa không gian làm việc',
            workspace_delete_failed: 'Không thể xóa không gian làm việc. Vui lòng thử lại.',
            member_remove_forbidden: 'Bạn không có quyền xóa thành viên này.',
            member_remove_failed: 'Không thể xóa thành viên. Vui lòng thử lại.',
            cannot_remove_self: 'Hãy dùng "Rời khỏi không gian làm việc" để tự xóa bản thân.',
            cannot_remove_last_owner: 'Không gian làm việc phải luôn có chủ sở hữu. Hãy chỉ định người khác làm chủ sở hữu trước.',
            invite_revoke_forbidden: 'Bạn không có quyền thu hồi lời mời này.',
            invite_revoke_failed: 'Không thể thu hồi lời mời. Vui lòng thử lại.',
        },
        dashboard: {
            doc_title: 'Sơ đồ',
            filter_all: 'Tất cả',
            filter_mydiagrams: 'Sơ đồ của tôi',
            filter_shared: 'Được chia sẻ với tôi',
            filter_archived: 'Đã lưu trữ',
            empty_all: 'Không có sơ đồ nào trong "Tất cả sơ đồ"',
            empty_mydiagrams: 'Không có sơ đồ nào trong "Sơ đồ của tôi"',
            empty_shared: 'Không có sơ đồ nào trong "Được chia sẻ với tôi"',
            empty_archived: 'Không có sơ đồ nào trong "Đã lưu trữ"',
            example_diagram_badge: 'Sơ đồ mẫu',
            import_sql: 'SQL',
            import_dbml: 'DBML',
            import_playground: 'Playground',
        },
        settings_page: {
            nav: {
                back_to_app: 'Quay lại ứng dụng',
                group_personal: 'Cá nhân',
                group_organization: 'Tổ chức',
                billing: 'Thanh toán',
            },
            profile: {
                member_since: 'Thành viên từ {{date}}',
                general: 'Chung',
                email: 'Email',
                full_name: 'Họ và tên',
                full_name_placeholder: 'Nhập tên',
                account_protection: 'Bảo vệ tài khoản',
                mfa_label: 'Xác thực đa yếu tố (MFA)',
                mfa_sub: 'Lớp bảo mật bổ sung cho tài khoản · Sắp ra mắt',
                mfa_enable: 'Bật MFA',
                mfa_soon_tooltip: 'Sắp ra mắt',
                workspace_access: 'Quyền truy cập không gian làm việc',
                leave_workspace: 'Rời khỏi không gian làm việc',
                leave_workspace_sub: 'Xóa bạn khỏi không gian làm việc',
                leave_owner_tooltip: 'Hãy chuyển quyền sở hữu trước khi rời khỏi không gian làm việc',
            },
            workspace: {
                header: 'Không gian làm việc',
                general: 'Chung',
                name_label: 'Tên không gian làm việc',
                name_placeholder: 'tên không gian làm việc',
                stat_member_singular: 'Thành viên',
                stat_member_plural: 'Thành viên',
                stat_team_singular: 'Nhóm',
                stat_team_plural: 'Nhóm',
                members_section: 'Thành viên',
                no_members: 'Không có thành viên',
                count_member_singular: 'thành viên',
                count_member_plural: 'thành viên',
                view_members_btn: 'Xem thành viên',
                danger_zone: 'Khu vực nguy hiểm',
                delete_workspace: 'Xóa không gian làm việc',
                delete_workspace_sub: 'Thao tác này sẽ xóa vĩnh viễn không gian làm việc',
                delete_owner_only_tooltip: 'Chỉ chủ sở hữu mới có thể xóa không gian làm việc',
                delete_cancel_sub_tooltip: 'Hãy hủy gói đăng ký trước khi xóa không gian làm việc',
            },
            members: {
                header: 'Thành viên',
                col_name: 'Tên',
                col_email: 'Email',
                col_role: 'Vai trò',
                col_joined: 'Ngày tham gia',
                active_members: 'Thành viên đang hoạt động',
                invited_section: 'Đã mời',
                no_members: 'Chưa có thành viên nào.',
                options_aria: 'Tùy chọn',
                leave_workspace_item: 'Rời khỏi không gian làm việc...',
                remove_member_item: 'Xóa thành viên...',
                remove_owner_only_tooltip: 'Chỉ chủ sở hữu mới có thể xóa thành viên',
                remove_owner_row_tooltip: 'Không thể xóa chủ sở hữu khỏi không gian làm việc',
                remove_invite_item: 'Xóa lời mời...',
                role_invited_suffix: '{{role}} (Đã mời)',
            },
            preferences: {
                section_general: 'Chung',
                section_diagram_defaults: 'Cài đặt sơ đồ',
                section_diagram_views: 'Chế độ xem sơ đồ',
                section_notifications: 'Thông báo',
                theme_label: 'Giao diện',
                theme_sub: 'Chọn bảng màu giao diện của bạn',
                theme_dark: 'Tối',
                theme_light: 'Sáng',
                theme_system: 'Theo hệ thống',
                language_sub: 'Chọn ngôn ngữ giao diện của bạn',
                timezone_label: 'Múi giờ',
                timezone_sub: 'Chọn múi giờ của bạn',
                timezone_options: {
                    honolulu: 'GMT-10:00 — Hawaii',
                    anchorage: 'GMT-09:00 — Alaska',
                    los_angeles: 'GMT-08:00 — Giờ Thái Bình Dương',
                    denver: 'GMT-07:00 — Giờ Miền Núi',
                    chicago: 'GMT-06:00 — Giờ Miền Trung',
                    new_york: 'GMT-05:00 — Giờ Miền Đông',
                    caracas: 'GMT-04:00 — Caracas',
                    sao_paulo: 'GMT-03:00 — São Paulo',
                    azores: 'GMT-01:00 — Azores',
                    london: 'GMT+00:00 — London',
                    paris: 'GMT+01:00 — Paris, Berlin',
                    kyiv: 'GMT+02:00 — Kyiv, Athens',
                    istanbul: 'GMT+03:00 — Istanbul',
                    dubai: 'GMT+04:00 — Dubai',
                    karachi: 'GMT+05:00 — Karachi',
                    kolkata: 'GMT+05:30 — Ấn Độ',
                    dhaka: 'GMT+06:00 — Dhaka',
                    bangkok: 'GMT+07:00 — Bangkok, Jakarta',
                    shanghai: 'GMT+08:00 — Bắc Kinh, Singapore',
                    tokyo: 'GMT+09:00 — Tokyo, Seoul',
                    sydney: 'GMT+10:00 — Sydney',
                    auckland: 'GMT+12:00 — Auckland',
                },
                input_mode_sub: 'Chọn cách điều khiển điều hướng canvas',
                background_sub: 'Chọn màu nền cho canvas',
                grid_sub: 'Chọn kiểu lưới của canvas',
                show_align_lines_sub: 'Hiển thị đường khi căn chỉnh đối tượng',
                show_cursors_sub: 'Hiển thị con trỏ của những người cộng tác khác',
                show_comments_sub: 'Hiển thị bình luận trên canvas',
                show_scrollbars_sub: 'Hiển thị thanh cuộn khi di chuyển trên canvas',
                show_undo_redo_label: 'Hiển thị điều khiển hoàn tác/làm lại',
                show_undo_redo_sub: 'Hiển thị điều khiển để hoàn tác và làm lại thay đổi',
                notif_shared_label: 'Sơ đồ được chia sẻ với tôi',
                notif_shared_sub: 'Khi ai đó chia sẻ sơ đồ với tôi',
                notif_mentions_label: 'Lượt nhắc đến trong bình luận',
                notif_mentions_sub: 'Khi ai đó @nhắc đến tôi trong bình luận',
                notif_updates_label: 'Cập nhật sản phẩm',
                notif_updates_sub: 'Cập nhật hàng tháng về các tính năng và cải tiến mới',
                show: 'Hiện',
                hide: 'Ẩn',
                on: 'Bật',
                off: 'Tắt',
            },
            billing: {
                header: 'Thanh toán',
                plan_free: 'Gói miễn phí',
                status_current: 'Hiện tại',
                no_renewal_needed: 'Không cần gia hạn',
                payment_header: 'Thanh toán',
                no_payments: 'Không có khoản thanh toán',
                invoices_header: 'Hóa đơn',
                no_invoices: 'Không có hóa đơn',
            },
            usage: {
                doc_title: 'Mức sử dụng',
                overview_title: 'Tổng quan',
                resource_limits_title: 'Giới hạn tài nguyên',
                label_diagrams: 'Sơ đồ',
                label_tables: 'Bảng',
                label_areas: 'Khu vực',
                label_notes: 'Ghi chú dán',
                label_members: 'Thành viên',
                label_tables_per_diagram: 'Bảng / Sơ đồ',
                label_areas_per_diagram: 'Khu vực / Sơ đồ',
                label_notes_per_diagram: 'Ghi chú / Sơ đồ',
                need_more_title: 'Cần thêm?',
                need_more_free: 'Nâng cấp lên Basic để có thêm sơ đồ, lịch sử phiên bản và hỗ trợ ưu tiên.',
                need_more_paid: 'Nâng cấp lên Professional để có sơ đồ, chỗ ngồi không giới hạn và các tính năng nâng cao.',
            },
        },
        pages: {
            not_found: {
                page_not_found: 'Không tìm thấy trang',
                dont_have_access_to_diagram: 'Bạn không có quyền truy cập vào sơ đồ này, hoặc sơ đồ có thể không còn tồn tại.',
                back_home: 'Về trang chủ'
            },
            error: {
                title: 'Lỗi',
                link_is_invalid: 'Liên kết này không hợp lệ hoặc đã được nhập sai.',
                something_wrong: 'Đã xảy ra lỗi.',
                back_home: 'Về trang chủ',
                please_try_later: 'Vui lòng thử lại sau',
            },
            billing_success: {
                doc_title: 'Đã nâng cấp gói',
                heading: 'Thanh toán thành công',
                subtitle: 'Gói của bạn đã được nâng cấp thành công.',
                cta: 'Bắt đầu thiết kế',
            },
            email_verified: {
                doc_title: 'Email đã xác minh',
            },
            forgot_password: {
                doc_title: 'Quên mật khẩu',
            },
            password_updated: {
                doc_title: 'Đã cập nhật mật khẩu',
            },
            reset_password: {
                doc_title: 'Đặt lại mật khẩu',
            },
            check_email: {
                doc_title: 'Kiểm tra email của bạn',
            },
            sign_in: {
                doc_title: 'Đăng nhập vào {{product}}',
            },
            sign_up: {
                doc_title: 'Đăng ký {{product}}',
            },
        },
    },
};

export const viMeta = {
    lang_origin: 'English',
    lang_eng: 'English',
    lang_code: 'vi',
};
